import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import clsx from 'clsx';

/**
 * ModalScrollPanel allows large blocks of content to become scrollable when their content a defined length.
 * The length that the content needs to exceed is standardized and based upon the size of the ModalScrollPanel's parent modal.
 * To use the component just wrap the desired scrollable content in a ModalScrollPanel.
 *
 */
import { jsx as _jsx } from "react/jsx-runtime";
function ModalScrollPanel(_ref) {
  let {
    children,
    className,
    ...rest
  } = _ref;
  const ref = useRef();
  const containerClassName = clsx({
    'modal-scroll-panel': true
  }, className);

  // Safely handle passing refs to children
  const childrenWithRefs = typeof children === 'string' ? children // If children is just a string, return it as-is (no ref needed)
  : React.Children.map(children, child => {
    if (/*#__PURE__*/React.isValidElement(child) && typeof child.type.$$typeof === 'symbol' // Is a wrapped React component
    && child.type.$$typeof.toString() === 'Symbol(react.forward_ref)') {
      // Is wrapped by forwardRef
      // Clone and add ref to component we now know can handle it
      return /*#__PURE__*/React.cloneElement(child, {
        ref
      });
    }
    // For all other elements (function components without forwardRef, etc.),
    // return them unchanged to avoid the ref warning
    return child;
  });
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "modalScrollPanel",
    className: containerClassName,
    ref: ref,
    ...rest,
    children: childrenWithRefs
  });
}
export default ModalScrollPanel;